import React from 'react';
import { camelCase, upperFirst } from 'lodash';

import WarningModal from './WarningModal';

import { formatMessage, FormattedMessage, formatLocalizedString } from '../../../utils/i18n';
import ComparisonItem from '@/types/comparison-item';
import { NoAssetClass } from '@/types/no-asset-class';
import { COMPARISON_ITEM_TYPES } from '@/utils/constants';

type Props = {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  filteredItems: ComparisonItem[];
  tab: NoAssetClass;
};

const NoAssetClassModalBody: React.FC<{ filteredItems: ComparisonItem[]; hasGroupPortfolios: boolean }> = ({ filteredItems, hasGroupPortfolios }) => {
  const bodyMessageId = hasGroupPortfolios ? 'NoAssetClassModal.BodyWithoutGroup' : 'NoAssetClassModal.Body';

  return (
    <>
      <p className="subtitle">
        <FormattedMessage id="NoAssetClassModal.Subtitle" />
      </p>
      <p>
        <FormattedMessage id={bodyMessageId} />
      </p>
      <ul className="items-list">
        {filteredItems.map(item => (
          <li key={item._id}>{formatLocalizedString(item.name)}</li>
        ))}
      </ul>
    </>
  );
};

const NoAssetClassModal: React.FC<Props> = ({ show, onConfirm, onCancel, filteredItems, tab }) => {
  const convertedTabLabel = upperFirst(camelCase(tab));
  const hasGroupPortfolios = filteredItems.some(item => item.type === COMPARISON_ITEM_TYPES.GROUP);

  return (
    <WarningModal
      body={<NoAssetClassModalBody filteredItems={filteredItems} hasGroupPortfolios={hasGroupPortfolios} />}
      className="no-asset-class-modal"
      confirmLabel={formatMessage(`NoAssetClassModal.${convertedTabLabel}.Action`)}
      onCancel={onCancel}
      onConfirm={onConfirm}
      show={show}
      title={formatMessage(`NoAssetClassModal.${convertedTabLabel}.Title`)}
    />
  );
};

export default NoAssetClassModal;
